<template>
  <div class="aspect-ratio-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Aspect Ratio' | trans }}</div>
      <div class="text-muted font-weight-bold">{{ currentAspectRatio.name | trans }}</div>
    </div>

    <div class="aspect-ratio-container">
      <div
          v-for="aspectRatio in aspectRatios"
          :class="{ 'active': currentAspectRatio.name === aspectRatio.name}"
          class="aspect-ratio-btn"
          @click="setAspectRatio(aspectRatio.size)"
      >
        {{ aspectRatio.size }}
        <div :class="aspectRatio.style"></div>
        <div
            :class="{ 'active': currentAspectRatio.name === aspectRatio.name}"
            class="checkmark-box"
        >
          <i class="fa fa-check"></i>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import AspectRatioManager from "../../manager/AspectRatioManager";

export default {
  name: "AspectRatio",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      aspectRatios: []
    };
  },
  mounted: function () {

  },
  created: function () {
    this.aspectRatios = AspectRatioManager.ratios;
  },
  methods: {
    setAspectRatio(size) {
      this.creatorStudio.settings.conversion.options.aspect_ratio = size;
    }
  },
  computed: {
    currentAspectRatio() {
      return AspectRatioManager.getBySize(this.creatorStudio.settings.conversion.options.aspect_ratio);
    }
  }
};
</script>
<style lang="scss">
.aspect-ratio-box {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.checkmark-box {
  color: white;
  background: #1266F1;
  border-radius: 50%;
  position: absolute;
  padding: 5px;
  width: 24px;
  height: 24px;
  right: -10px;
  top: -13px;
  justify-content: center;
  align-items: center;
  display: none;

  &.active {
    display: flex !important;
  }
}

.aspect-ratio-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.aspect-ratio-btn {
  cursor: pointer;
  border-radius: 9px;
  background: #383838;
  position: relative;
  display: flex;
  height: 48px;
  border: 3px solid transparent;
  gap: 10px;
  padding: 10px;
  align-items: center;

  &.active {
    border: 3px solid #1266F1;
  }

  &:hover {
    background: #323232;
  }
}


.box-1-1 {
  width: 20px;
  height: 20px;
  border: 2px solid white;
  margin-left: 0.5rem;
}

.box-16-9 {
  width: 36px;
  height: 20px;
  border: 2px solid white;
  margin-left: 0.5rem;
}

.box-9-16 {
  width: 20px;
  height: 32px;
  border: 2px solid white;
  margin-left: 0.5rem;
}

.box-4-5 {
  width: 20px;
  height: 23px;
  border: 2px solid white;
  margin-left: 0.5rem;
}

.box-4-3 {
  width: 23px;
  height: 16px;
  border: 2px solid white;
  margin-left: 0.5rem;
}

.box-3-2 {
  width: 22px;
  height: 18px;
  border: 2px solid white;
  margin-left: 0.5rem;
}

.box-21-9 {
  width: 41px;
  height: 19px;
  border: 2px solid white;
  margin-left: 0.5rem;
}
</style>
